import { type PID } from '@fs/zion-tree-types'
import { pidRegexStr } from '@fs/zion-pid'

export const SOURCE_GRID_ROUTE_PATH = `/source-grid/:pid(${pidRegexStr as PID})` as const
